export const CONFIG_DISENO_GET_SUCCESS = "CONFIG_DISENO_GET_SUCCESS";
export const CONFIG_DISENO_GET_FAILURE = "CONFIG_DISENO_GET_FAILURE";
